
import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { deleteVehiculo, listadoVehiculos, savingVehiculos, setVehiculoXConductor, vehiculoXID } from '../../services';

import Swal from "sweetalert2";




const storeApi = (set) => ({

    isLoadingvehiculo: false,
    vehiculos: [],
    activeVehiculo: null,
    totalVehiculos: 0,



    vehiculoClear: () => {
        set({ activeVehiculo: null });
    },


    startVehiculoPorID: async(id) => {
        try {
            set({ isLoadingvehiculo: true });
            const data = await vehiculoXID(id);
            set({ isLoadingvehiculo: false, activeVehiculo: data });
            return true;
        } catch (error) {
            Swal.fire('Error', error.message, 'error');
            return false;
        }
    },



    startListadoVehiculos: async() => {
        try {
            set({ isLoadingUsuario: true });
            const data = await listadoVehiculos();
            set({ vehiculos: data, isLoadingUsuario: false });
            return true;
        } catch (error) {
            Swal.fire('Error', error.message, 'error');
            set({ isLoadingUsuario: false });
            return false;
        }
    },



    startListVehiculoConductor: async(id) => {
        try {
            const data = await setVehiculoXConductor(id);
            set({ vehiculos: data });
            return true;
        } catch (error) {
            return false;
        }
    },


    startCreateVehiculo: async(vehiculo) => {
        try {
            const data = await savingVehiculos(vehiculo);
            if(vehiculo.id){
                set(state => ({ 
                    vehiculos: state.vehiculos.map( (c) => {
                        if(c.id === data.id){ return data }
                        return c
                    })
                }));
            }else {
                set( state => ({ vehiculos: [ data, ...state.vehiculos ] }));
            }
            return true;
        } catch (error) {
            Swal.fire('Error', error.message, 'error');
            return false;
        }
    },

    

    startBloquearVehiculo: async(id) => {
        try {
            const data = await deleteVehiculo(id);
            set(state => ({ 
                vehiculos: state.vehiculos.map( (c) => {
                    if(c.id === data.id){ return data }
                    return c
                })
            }));
            return true;
        } catch (error) {
            Swal.fire('Error', error.message, 'error');
            return false;
        }
    },

    
});




export const useVehiculoStore = create()(
    devtools(
        storeApi
    )
)
